{
  "title": "Virtue (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "Abjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "You touch one creature, imbuing it with vitality. If the target has at least 1 hit point, it gains a number of temporary hit points equal to 1d4 + your spellcasting ability modifier. The temporary hit points are lost when the spell ends."
  ],
  "spellLists": ["cleric"]
}
